import {tracking as barkTrackingLogEvent} from "@bark/bark-core";

export default function SelectFilter(){

	const { Handlebars } = window;

    const hbTemplate = Handlebars.compile(document.getElementById('select-filter-template').innerHTML);

    const getHtml = (data) => {
        return hbTemplate(data);
    };

    const registerListner = (eventEmitter, filterKey, group, filterPrefix) => {
        $(`#select_items_${filterKey} .filter-select-option`).off('click').on('click', function (e) {
            e.preventDefault();
            if(!$(this).hasClass("selected")){

                let prevSelectedValue = getSelectedValue(filterKey);

                setSelected($(this), filterKey, filterPrefix);
                eventEmitter.emit('filters.applied', {filter: filterKey, group: group});

                if($(this).data('filterId') === 'all'){
                    barkTrackingLogEvent(
                        'seller-list-&-profile',
                        'seller_list_filters - Filter removed',
                        {project_id: getProjectHash(), filter_name: filterKey, filter_value: prevSelectedValue}
                    );
                } else {
                    barkTrackingLogEvent(
                        'seller-list-&-profile',
                        'seller_list_filters - Filter applied',
                        {project_id: getProjectHash(), filter_name: filterKey, filter_value: $(this).data('filterId')}
                    );
                }

            }
        });

        $(`#select_selected_${filterKey}`).off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".filter-select-items").removeClass('d-block');
            if(!$(this).hasClass("disabled")){

                $(`#select_items_${filterKey}`).addClass('d-block');

                barkTrackingLogEvent(
                    'seller-list-&-profile',
                    'seller_list_filters - Filter view',
                    {project_id: getProjectHash(), filter_name: filterKey}
                );
            }
        });
    };

    const getSelectedValue = (filterKey) => {
        return $(`#select_items_${filterKey}`).find(`.selected`).data('filterId');
    };

    const disableFilter = (filterKey) => {
        $(`#select_selected_${filterKey}`).addClass('disabled');
    };

    const enableFilter = (filterKey) => {
        $(`#select_selected_${filterKey}`).removeClass('disabled');
    };


    const initFilter = (filterKey, filterPrefix) => {
        let selectedOption = $(`#select_items_${filterKey}`).find(`.selected`);
        if(!selectedOption.length){
            selectedOption = $(`#select_items_${filterKey}`).find(`[data-is-default-selected="true"]`);
        }
        setSelected(selectedOption, filterKey, filterPrefix);
    };

    const setSelected = ($option, filterKey, filterPrefix) => {
        $(`#select_items_${filterKey}`).find(`.selected`).removeClass("selected");
        $option.addClass("selected");

        let isDefaultSelected = $option.attr("data-is-default-selected");
        let selectText = (filterPrefix && !isDefaultSelected) ? `${filterPrefix} ${$option.data('filterValue').toLowerCase()}` : $option.data('filterValue');
        $(`#select_selected_${filterKey}`).empty().append(selectText);
    };

    const getProjectHash = () => {
        return $('#project-id').val();
    };

    return {
        getHtml,
        registerListner,
        getSelectedValue,
        disableFilter,
        enableFilter,
        initFilter,
    };
}
